<template>
  <div class="home" @click.self="changeCurrent('')">

    <!-- 顶部操作栏 start -->
    <div class="action-container">
      <!-- <div class="item">
        <img class="icon" src="../assets/img/back@2x.png">
        <div class="text">撤回</div>
      </div>

      <div class="item">
        <img class="icon">
        <div class="text">后退</div>
      </div> -->

      <div class="item" @click="previewImage">
        <img class="icon" src="../assets/img/example@2x.png">
        <div class="text">示例</div>
      </div>

      <div class="item" @click="toggleBillCostModal">
        <img class="icon" src="../assets/img/download_white@2x.png">
        <div class="text">渲染</div>
      </div>
    </div>

    <!-- 顶部操作栏 end -->

    <!-- 海报编辑区域 start -->
    <div id="poster" ref="poster" :class="['poster', {scale: isScaleEditorArea}]">
      <div
        id="border"
        :style="_borderStyle"
        :class="['border', {
          show: current
        }]"
      >
        <div class="black-container">
          <div class="line top" />
          <div class="line right" />
          <div class="line bottom" />
          <div class="line left" />
        </div>
        <img
          class="icon delete"
          src="../assets/img/delete@2x.png"
          @click="deleteElement"
        >
        <img
          class="icon scale"
          src="../assets/img/scale@2x.png"
          alt=""
          @touchmove="handleBorderTouchmove"
        >
      </div>

      <!-- <img style="width: 3rem; height: 3rem" src="https://resource.jinduo.com/Image/returnMultimedia?path=/upload/adminback/image/20200928/b90c4aa0712cf9b6a50b7f18ff1b9467.png" alt=""> -->

      <Element
        v-for="(item, index) in elements"
        :key="index"
        :item="item"
        @changeStyle="changeStyle"
        @changeBorderStyle="changeBorderStyle"
        @changeCurrent="changeCurrent"
      />
    </div>
    <!-- 海报编辑区域 end -->

    <!-- 留白 -->
    <div class="block" />

    <!-- 底部操作栏 start -->
    <div class="footer-container">

      <!-- 工具栏 -->
      <div v-if="isShowToolMenu" class="tool-container">
        <!-- 字体选择器 start -->
        <div
          v-if="isShowToolMenu === 'TEXT_COLOR'"
          class="color-selector-container"
        >
          <div
            v-for="(item, index) in colorList"
            :key="index"
            :class="['item', { active: currentDetail.style.color === item }]"
            :style="{ background: item}"
            @click="handleChangeTextColorValue($event, item)"
          />

        </div>
        <!-- 字体选择器 end -->

        <!-- 字号编辑器 -->
        <div
          v-if="isShowToolMenu === 'TEXT_SIZE'"
          class="size-change-container"
        >
          <div class="align-container">
            <span class="title">对齐方式</span>
            <div class="align-list">
              <img
                v-for="(item, index) in alignList"
                :key="index"
                :src="currentDetail.style && currentDetail.style.textAlign === item.value ? item.activeIcon : item.icon"
                @click="changeTextAlignValue($event, item.value)"
              >
            </div>
          </div>

          <div class="slider-container">
            <img src="../assets/img/font_size_reduce@2x.png" alt="" @click="editFontSizeValue --">
            <div class="slider-wrapper">
              <van-slider v-model="editFontSizeValue" :min="10" :max="100" active-color="#7b90ff" />
            </div>
            <img src="../assets/img/font_size_add@2x.png" alt="" @click="editFontSizeValue ++">
          </div>
        </div>
        <!-- 字号编辑器 -->

        <!-- 字体编辑器 -->
        <div
          v-if="isShowToolMenu === 'TEXT_FONT_FACE'"
          class="font-face-change-container"
        >
          <div class="font-face-list">
            <div
              v-for="(item) in fontList"
              :key="item.id"
              :class="['font-face-container', { active: currentDetail.style.fontFamily === item.name }]"
              @click="handleSelectFont(item)"
            >
              <span v-if="item.loaded" :style="{fontFamily: item.name}">
                {{ item.name }}
              </span>
              <span v-else>
                {{ item.name }}
              </span>

              <div class="icon-container">
                <img v-if="loadingFont === item.name" class="loading" src="../assets/img/loading_purple@2x.png" alt="">
                <img v-else-if="currentDetail.style.fontFamily === item.name" src="../assets/img/finish@2x.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- 字体编辑器 -->
      </div>
      <!-- 工具栏 -->

      <!-- 没有聚焦时的底部栏 -->
      <div v-if="!current" class="footer">
        <div class="item" @click="handleAddText">
          <img class="icon" src="../assets/img/add_text@2x.png">
          <div>加字</div>
        </div>
        <!-- <div class="item" @click="handleAddImage">
          <van-uploader>
            <img class="icon" src="../assets/img/add_pic@2x.png">
            <div>加图</div>
          </van-uploader>
        </div> -->
        <!-- <van-uploader class="item" :after-read="uploadFile"> -->
        <div class="item" @click="toggleImageMenuModal">
          <img class="icon" src="../assets/img/add_pic@2x.png">
          <div>加图</div>
        </div>
        <!-- </van-uploader> -->
      </div>

      <!-- 选择文字时的底部栏 -->
      <div v-else-if="footerMenuSetting.type === 'text'" class="footer">
        <div
          :class="['item', { active: footerMenuSetting.activeAction === 'textValue' }]"
          @click="handleChangeText"
        >
          <img
            class="icon"
            :src="footerMenuSetting.activeAction === 'textValue' ? require('../assets/img/edit_purple@2x.png') : require('../assets/img/edit@2x.png')"
          >
          <div>编辑</div>
        </div>
        <div
          :class="['item', { active: footerMenuSetting.activeAction === 'TEXT_COLOR' }]"
          @click="handleChangeTextColor"
        >
          <img
            class="icon"
            :src="footerMenuSetting.activeAction === 'TEXT_COLOR' ? require('../assets/img/color_purple@2x.png') : require('../assets/img/color@2x.png')"
          >
          <div>颜色</div>
        </div>
        <div
          :class="['item', { active: footerMenuSetting.activeAction === 'TEXT_SIZE' }]"
          @click="handleChangeTextSize"
        >
          <img
            class="icon"
            :src="footerMenuSetting.activeAction === 'TEXT_SIZE' ? require('../assets/img/font_size_purple@2x.png') : require('../assets/img/font_size@2x.png')"
          >
          <div>字号</div>
        </div>
        <div
          :class="['item', { active: footerMenuSetting.activeAction === 'TEXT_FONT_FACE' }]"
          @click="handleChangeTextFontFace"
        >
          <img
            class="icon"
            :src="footerMenuSetting.activeAction === 'TEXT_FONT_FACE' ? require('../assets/img/font_purple@2x.png') : require('../assets/img/font@2x.png')"
          >
          <div>字体</div>
        </div>
      </div>

      <!-- 选择图片时的底部栏 -->
      <div v-else-if="footerMenuSetting.type === 'image'" class="footer">
        <van-uploader class="item" :after-read="uploadFile">
          <div class="item">
            <img class="icon" src="../assets/img/add_pic@2x.png">
            <div>换图</div>
          </div>
        </van-uploader>
      </div>
    </div>
    <!-- 底部操作栏 end -->

    <!-- 编辑文本模态框 start -->
    <van-popup
      v-model="isEditTextModalShow"
      class="textEditModal"
    >
      <div class="header">
        <span>清空</span>
      </div>
      <div class="content">
        <textarea
          v-model="editTextValue"
          class="textarea"
        />
      </div>
      <div class="modal-footer">
        <div class="btn plain" @click="toggleEditTextModal">取消</div>
        <div class="btn" @click="toggleEditTextModal">确定</div>
      </div>
    </van-popup>
    <!-- 编辑文本模态框 end -->

    <!-- 图片菜单模态框 start -->
    <van-popup v-model="isShowImageMenu" position="bottom" :style="{ height: '2.74rem', fontSize: 0 }">
      <div class="image-menu-container">
        <div class="item">
          <van-uploader :after-read="uploadFile">
            <p>本地上传</p>
            <img src="../assets/img/upload@2x.png" alt="">
          </van-uploader>
        </div>
        <div class="item" @click="handleAddQrCoed">
          <p>个人名片</p>
          <img src="../assets/img/qr_code@2x.png" alt="">
        </div>
      </div>
    </van-popup>
    <!-- 图片菜单模态框 end -->

    <!-- 积分消耗模态框 start -->
    <van-popup v-model="isShowBillCost" position="center" style="border-radius: .1rem">
      <div class="bill-cost-container">
        <p class="title">
          积分余额: {{ userIntegral }}
        </p>
        <div class="content">
          此次渲染需要消耗 <span class="num">{{ integral }}</span> 积分
          <div v-if="(userIntegral < integral)" class="less">
            当前积分不足
          </div>
        </div>
        <div v-if="(userIntegral < integral)" class="footer less">
          <div class="btn" @click="handleGetIntegral">获取积分</div>
        </div>
        <div v-else class="footer">
          <div class="btn plain" @click="toggleBillCostModal">取消</div>
          <div class="btn" @click="handleConfirmRender">确定</div>
        </div>
      </div>
    </van-popup>
    <!-- 积分消耗模态框 end -->

  </div>
</template>

<script>
// @ is an alias to /src
import Element from '../components/Element'
import html2canvas from 'html2canvas'
import _ from 'lodash'
import { COLOR_LIST, ALIGN_LIST } from '../constances/font'
import { idCreator, loadFont, getCanvasImgUrl, dataURLtoFile, getImgUrl } from '../utils/util'
import { uploadFileReq } from '../utils/upload'
import { getBase64Image } from '../utils/img2base64'
import { uploadFile } from '../api/uploadFile'
import { getFontList } from '../api/font'
import { fetchBill } from '../api/bill'
import { fetchPosterDetail, addUserPoster } from '../api/poster'
import { IMAGE_PREFIX } from '../constances/server'

const INIT_TEXT = {
  style: {
    top: 'calc( 50% - .15rem )',
    left: 'calc( 50% - .5rem )',
    width: '1rem',
    height: '.3rem',
    fontSize: '.24rem',
    color: '#000000',
    textAlign: 'left',
    fontFamily: '微软雅黑'
  },
  value: '输入文字',
  type: 'text',
  isEdit: true
}

const INIT_IMAGE = {
  style: {
    top: 'calc( 50% - .15rem )',
    left: 'calc( 50% - .5rem )',
    width: '3rem',
    minHeight: '3rem',
    fontSize: '0',
    color: '#000000',
    textAlign: 'left',
    backgroundColor: '#ffffff',
    backgroundSize: '100% 100%'
  },
  value: '',
  base64: '',
  type: 'image',
  isEdit: true
}

export default {
  name: 'Home',
  components: {
    Element
  },
  data() {
    return {
      elements: [],
      loadingFont: '', // 加载字体中
      fontList: [], // 字体列表
      isMoving: false, // 元素是否在运动，标记动作
      current: undefined, // 当前focus
      borderStyle: {}, // 边框style
      isEditTextModalShow: false, // 是否显示编辑文字弹框
      editTextValue: '', // 编辑文字值,
      isShowToolMenu: false, // 是否显示文字编辑菜单栏 false: 隐藏 TEXT_COLOR: 颜色
      colorList: COLOR_LIST, // 颜色列表
      editTextColor: '', //  编辑文字颜色
      alignList: ALIGN_LIST, // 文字对齐方式
      editFontSizeValue: 0, // 当前字体大小
      isShowImageMenu: false, // 加图菜单
      qrCode: '', // 小程序码
      posterId: undefined, // 海报id
      integral: '', // 积分消耗
      userIntegral: 0, // 用户积分
      isShowBillCost: false // 积分消耗模态框
    }
  },
  computed: {
    // 计算编辑框的样式
    _borderStyle() {
      let style = {}
      if (this.current) {
        const node = document.querySelector(`#${this.current}`)
        const height = node.offsetHeight + 'px'
        const width = node.offsetWidth + 'px'
        const top = node.offsetTop + 'px'
        const left = node.offsetLeft + 'px'
        const _style = this.elements.filter(item => item.id === this.current)[0].style
        style = {
          height,
          width,
          top,
          left,
          ..._style
        }
      }

      return style
    },
    // 底部栏显示设置 ，暂时只根据type 显示操作 之后或许会有某些元素禁用某些操作的
    footerMenuSetting() {
      let activeAction = null
      if (this.isEditTextModalShow) {
        activeAction = 'textValue'
      } else if (this.isShowToolMenu) {
        activeAction = this.isShowToolMenu
      }
      return {
        type: this.elements.filter(item => item.id === this.current)[0].type,
        activeAction
      }
    },
    // 当前元素的详情
    currentDetail() {
      return this.current ? this.elements.filter(item => item.id === this.current)[0] : {}
    },
    // 缩小编辑区
    isScaleEditorArea() {
      return !!this.isShowToolMenu
    }
  },
  watch: {
    // 改变输入框的值时改变当前选择元素的文字值
    editTextValue() {
      if (this.current && this.isEditTextModalShow) {
        this.elements.filter(item => item.id === this.current)[0].value = this.editTextValue || '输入文字'
      }
    },
    editFontSizeValue(val) {
      if (this.current) {
        this.elements.filter(item => item.id === this.current)[0].style.fontSize = `${val / 100}rem`
      }
    },
    // 改变元素
    currentDetail(val) {
      if (val.type !== 'text' && !!this.isShowToolMenu) {
        this.isShowToolMenu = false
      } else if (val.type === 'text') {
        this.editFontSizeValue = parseFloat(val.style.fontSize) * 100
      }
    }
  },
  created() {
    this.getFontList()
    this.getQrCode()
    this.getPosterDetail()
    this.getUserBill()
  },
  mounted() {
  },
  methods: {
    // 改变当前元素样式
    changeStyle(e) {
      const { id, style } = e
      const index = this.elements.findIndex(item => item.id === id)
      if (index > -1) {
        this.elements[index].style = {
          ...this.elements[index].style,
          ...style
        }
      }
    },
    changeBorderStyle(e) {
    },
    // 改变当前元素
    changeCurrent(e) {
      if (e) {
        this.current = e
      } else {
        this.current = ''
      }
    },
    // 开始渲染
    createPoster() {
      if (this.userIntegral >= this.integral) {
        this.current = undefined
        this.$toast.loading({
          message: '渲染中...',
          forbidClick: true,
          duration: 0
        })
        this.toggleBillCostModal()

        // 渲染的时候把图片转为base64
        const images = this.elements.filter(item => item.type === 'image').map(item => ({ id: item.id, value: item.value }))

        console.log(images)

        const promiseArr = []

        images.map(item => {
          promiseArr.push(getBase64Image(item))
        })

        Promise.all(promiseArr).then(res => {
          res.map(item => {
            this.elements.filter(element => element.id === item.id)[0].base64 = item.value
          })

          this.$nextTick(() => {
            html2canvas(document.querySelector('#poster'), {
              scale: window.devicePixelRatio,
              useCORS: true,
              backgroundColor: 'transparent'
            }).then(canvas => {
              const base64 = canvas.toDataURL('image/png')
              const file = dataURLtoFile(base64, 'img.png')
              uploadFileReq({
                file,
                vm: this,
                loadingText: '渲染中...'
              }).then(res => {
                console.log(res)
                if (res.data.data.savepath) {
                  const elements = _.cloneDeep(this.elements)
                  elements.map(item => {
                    delete item.base64
                  })
                  addUserPoster({
                    poster_id: this.posterId,
                    details: JSON.stringify(elements),
                    image: res.data.data.savepath
                  }).then(res => {
                    if (res.data.id) {
                      this.$toast.success('渲染成功')
                      this.$wx.miniProgram.navigateTo({
                        url: this.$route.query.navigateTo + `?id=${res.data.id}` || `/posterPackage/userPosterDetail/index?id=${res.data.id}`
                      })
                    }
                  })
                } else {
                  throw Error('图片上传失败')
                }
              })
            }).catch((err) => {
              this.$toast.fail(err.message || '渲染失败')
            })
          })
        })
      } else {
        this.$toast.fail('积分不足')
      }
    },
    // 删除选中元素
    deleteElement() {
      console.log(this.current)
      this.elements = this.elements.filter(item => item.id !== this.current)
      this.current = ''
      this.borderStyle = {}
    },
    // 边框移动
    handleBorderTouchmove(e) {
      const x = e.targetTouches[0].clientX
      const y = e.targetTouches[0].clientY
      const element = this.elements.filter(item => item.id === this.current)[0]
      const nodeRect = document.querySelector(`#${this.current}`).getBoundingClientRect()
      const startX = nodeRect.x
      const startY = nodeRect.y
      console.log('resize start====', x, y, element)
      const width = Math.abs(x - startX) + 'px'
      const height = Math.abs(y - startY) + 'px'
      this.changeStyle({
        id: this.current,
        style: {
          ...element.style,
          width,
          minHeight: height
        }
      })
    },
    // 添加文字
    handleAddText: _.debounce(function() {
      const id = idCreator('text')
      this.elements.push({
        id,
        ..._.cloneDeep(INIT_TEXT)
      })
      this.$nextTick(() => {
        this.current = id
      })
    }, 0),
    // 添加图片
    handleAddImage: _.debounce(function(src) {
      const id = idCreator('image')
      const img = {
        id,
        ..._.cloneDeep(INIT_IMAGE)
      }
      this.toggleImageMenuModal()
      img.value = src
      this.elements.push(img)
      this.$nextTick(() => {
        this.current = id
      })
    }, 0),
    // 点击编辑文字
    handleChangeText() {
      this.editTextValue = this.currentDetail.value
      this.toggleEditTextModal()
    },
    // 显隐改变文字值模态框
    toggleEditTextModal() {
      this.isEditTextModalShow = !this.isEditTextModalShow
    },
    // 点击底部栏颜色
    handleChangeTextColor(e) {
      // this.toggleEditTextColorBox()
      const val = this.isShowToolMenu === 'TEXT_COLOR' ? false : 'TEXT_COLOR'
      this.toggleTextToolMenu(e, val)
    },
    // 点击改变颜色
    handleChangeTextColorValue(e, val) {
      this.elements.filter(item => item.id === this.current)[0].style.color = val
    },
    // 显示工具栏
    toggleTextToolMenu(e, val) {
      this.isShowToolMenu = val
    },
    // 点击改变字体
    handleChangeTextSize(e) {
      // 转换步进器，默认字体都用rem做单位
      console.log(parseFloat(this.currentDetail.style.fontSize) * 100)
      this.editFontSizeValue = parseFloat(this.currentDetail.style.fontSize) * 100
      const val = this.isShowToolMenu === 'TEXT_SIZE' ? false : 'TEXT_SIZE'
      this.toggleTextToolMenu(e, val)
    },
    // 改变字体对齐值
    changeTextAlignValue(e, val) {
      this.elements.filter(item => item.id === this.current)[0].style.textAlign = val
    },
    // 点击底部栏字体
    handleChangeTextFontFace(e) {
      // this.toggleEditTextColorBox()
      const val = this.isShowToolMenu === 'TEXT_FONT_FACE' ? false : 'TEXT_FONT_FACE'
      this.toggleTextToolMenu(e, val)
    },
    previewImage() {
      if (this.exampleSrc) {
        const url = getImgUrl(this.exampleSrc)
        this.$wx.previewImage({
          current: url,
          urls: [url]
        })
      } else {
        this.$toast.fail('暂无示例')
      }
    },
    // 上传图片
    uploadFile(file) {
      console.log(file)
      const formData = new FormData()
      formData.append('file', file.file)
      this.$toast.loading({
        message: '上传中...',
        forbidClick: true,
        duration: 0
      })
      uploadFile(formData, this.accept).then(result => {
        const res = result.data
        const resFile = result.data.data
        this.$toast.clear()
        console.log(res)
        if (res.code !== 200 || (res.code === 200 && resFile.error_msg)) {
          this.$toast.fail(resFile.error_msg)
        } else if (res.code === 200) {
          if (this.current) {
            this.changeImageSrc(IMAGE_PREFIX + '/Image/returnMultimedia?path=' + resFile.savepath)
          } else {
            this.handleAddImage(IMAGE_PREFIX + '/Image/returnMultimedia?path=' + resFile.savepath)
          }
        }
      })
    },
    // 换图
    changeImageSrc(url) {
      this.elements.filter(item => item.id === this.current)[0].value = url
    },
    // 图片选择器
    toggleImageMenuModal() {
      this.isShowImageMenu = !this.isShowImageMenu
    },
    // 获取字体列表
    async getFontList() {
      const res = await getFontList()
      if (res.data.code === 200) {
        this.fontList = res.data.data.list.map(item => ({
          ...item,
          loaded: false
        }))
      }
    },
    // 点击字体
    handleSelectFont(item) {
      if (item.loaded) {
        this.changeFontFamily(item.name)
      } else {
        this.loadingFont = item.name
        loadFont(item.name, item.url).then(res => {
          console.log('加载完成', res)
          this.fontList.filter(font => font.id === item.id)[0].loaded = true
          this.changeFontFamily(item.name)
          this.loadingFont = ''
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // 改变当前字体
    changeFontFamily(name) {
      this.elements.filter(item => item.id === this.current)[0].style.fontFamily = name
    },
    // 获取二维码
    getQrCode() {
      const { logo } = this.$route.query
      this.qrCode = logo
    },
    // 点击个人名片
    handleAddQrCoed() {
      this.handleAddImage(this.qrCode)
    },
    // 获取模板详情
    async getPosterDetail() {
      const { id } = this.$route.query
      const res = await fetchPosterDetail({
        id
      })
      this.posterId = res.data.id
      this.integral = res.data.integral
      this.exampleSrc = res.data.reference_img_url
      const el_id = idCreator('image')
      const img = {
        id: el_id,
        ..._.cloneDeep(INIT_IMAGE)
      }
      img.value = getCanvasImgUrl(res.data.img_url)
      img.isEdit = false // 模板不能移动
      img.style = {
        ...img.style,
        top: 0,
        left: 0,
        width: '100%',
        minHeight: '100%'

      }
      console.log(img)
      this.elements.push(img)
    },
    // 获取用户余额
    async getUserBill() {
      const res = await fetchBill()
      this.userIntegral = res.data.integral
    },
    // 显隐积分消耗模态框
    toggleBillCostModal() {
      this.isShowBillCost = !this.isShowBillCost
    },
    // 确认渲染
    handleConfirmRender() {
      this.createPoster()
    },
    // 获取积分跳转
    handleGetIntegral() {
      const { noPointTo } = this.$route.query
      const path = noPointTo || '/storePackage/points/index'
      this.$wx.miniProgram.redirectTo({
        url: path
      })
    }
  }
}
</script>

<style lang="scss">
/* components/poster/posterEditor.wxss */
@import '../assets/scss/mixin.scss';
@import '../assets/scss/val.scss';

body, .home {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  width: 100vw;
  background: #1b1b1b;
  color: #fff;
  overflow: hidden;
}

.action-container {
  display: flex;
  font-size: .24rem;
  line-height: .34rem;
}

.action-container .item {
  box-sizing: border-box;
  flex: 1;
  padding: .1rem 0 .2rem;
  height: 1.18rem;
  text-align: center;
  .text{
    font-size: .24rem;
  }
}

.action-container .item .icon {
  margin: 0 auto 0.04rem;
  width: .5rem;
  height: .5rem;
}

.poster {
  position: relative;
  margin: 0 auto 1.18rem;
  width: 5.40rem;
  height: 9.60rem;
  background: #fff;
  color: #000;
  overflow: hidden;
  z-index: 1;
  &.scale {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    transform: scale(.67);
  }
}

.poster .element,
.poster #border {
  position: absolute;
}

.footer-container{
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  background: #494b4b;
  margin-top: .1rem;
  z-index: 1;
}

.footer{
  display: flex;
}

.footer .item {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 1.18rem;
  font-size: .3rem;
  &.active {
    color: $btn-color;
    background: #262828;
  }
}

.footer .item .icon {
  width: .56rem;
	height: .56rem;
}

.testText{
  position: absolute;

}

// 编辑框
.border {
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0;
  .black-container {
    .line {
      position: absolute;
      z-index: 1;
      background: #000;
      box-sizing: border-box;
    }
    .left, .right {
      top: 0;
      height: 100%;
      width: .01rem;
      border-left: 0.01rem dashed #fff;
    }
    .top, .bottom {
      left: 0;
      width: 100%;
      height: .01rem;
      border-top: 0.01rem dashed #fff;
    }
    .top {
      top: 0;
    }
    .bottom {
      bottom: 0;
    }
    .left {
      left: 0;
    }
    .right {
      right: 0;
    }
  }
  .whiteBorder, .icon {
    position: absolute;
  }
  .icon {
    width: .28rem;
    height: .28rem;
    z-index: 1;
    &.scale {
      right: 0;
      bottom: 0;
      transform: translate(50%, 50%);
    }
    &.delete {
      left: 0;
      top: 0;
      transform: translate(-50%, -50%);
    }
  }
  &.transition {
    transition: all ease-in .1s;
  }
  &.show {
    opacity: 1;
  }
}

// 编辑文字弹框
.textEditModal{
  @include common-modal;
  padding: .3rem .57rem;
  height: 4.94rem;
  .header{
    text-align: right;
    font-size: .24rem;
    line-height: 1;
    color: $text-color;
  }
  .content {
    font-size: 0;
    .textarea {
      padding: .2rem;
      margin-top: .26rem;
      box-sizing: border-box;
      width: 5.56rem;
      height: 2.98rem;
      border-radius: .1rem;
      border: solid 0.02rem #dcdfe6;
      resize: none;
      color: #000;
      font-size: .24rem;
    }
  }
  .modal-footer{
    margin-top: .25rem;
    display: flex;
    justify-content: space-between;
    .btn {
      @include btn;

    }
  }
}

.tool-container {
  height: 3.44rem;
  background-color: #282828;
  // 颜色选择器
  .color-selector-container{
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: .36rem .60rem 0;
    .item {
      box-sizing: border-box;
      flex-shrink: 0;
      margin: 0 .05rem .1rem;
      width: .6rem;
      height: .6rem;
      border-radius: .04rem;
      &.active {
        border: 0.04rem solid #fff;
      }
    }
  }

  // 字体选择
  .size-change-container {
      box-sizing: border-box;
      padding: .78rem .6rem;
    .align-container{
      display: flex;
      color: #fff;
      font-size: .3rem;
      .title {
        margin-right: 1rem;
      }
      img {
        height: .46rem;
        width: auto;
        &:not(:last-child) {
          margin-right: 1rem;
        }
      }
    }
    .slider-container{
      margin-top: .76rem;
      display: flex;
      align-items: center;
      & > img {
        width: .72rem;
        height: .72rem;
      }
      .slider-wrapper {
        margin: 0 .28rem;
        width: 4.3rem;
      }
    }
  }

  .font-face-list{
    height: 3.44rem;
    overflow: auto;
    .font-face-container {
      position: relative;
      height: .76rem;
      line-height: .76rem;
      font-size: .3rem;
      color: #aeb1b6;
      text-align: center;
      &:not(:last-child)::after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: .02rem;
        background-image: linear-gradient(153deg,#262828 0%,  #444646 25%, #444646 75%, #262828 100%);
      }
      .icon-container {
        position: absolute;
        right: .6rem;
        top: 0;
        bottom: 0;
        margin: auto;
        width: .56rem;
        height: .56rem;
        img {
          width: 100%;
        }
        .loading {
          animation: rotate 2s linear infinite;
        }
      }
    }
  }
}

.image-menu-container{
  display: flex;
  width: 100%;
  height: 2.74rem;
  background: #262828;
  .item {
    flex: 1;
    justify-content: center;
    align-items: center;
    font-size: .3rem;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    text-align: center;
    &:not(:last-child) {
      border-right: .01rem solid #1b1d1d;
    }
    p {
      margin: .6rem auto .18rem;
    }
    img {
      width: 1.16rem;
      height: .88rem;
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  };
  100% {
    transform: rotate(360deg);
  }
}

.bill-cost-container{
  box-sizing: border-box;
  padding: .36rem .56rem .6rem;
  width: 6.7rem;
	height: 3.84rem;
  font-size: .28rem;
  color: #303133;
  .title{
    line-height: .42rem;
    margin: 0;
  }
  .content {
    margin: .42rem 0 0;
    text-align: center;
    line-height: .42rem;
    .num {
      color: #f56c6c;
    }
    .less {
      color: #f56c6c;
      font-size: .24rem;
    }
  }
  .footer {
    margin-top: 1rem;
    justify-content: space-between;
    &.less {
      margin-top: 0.42rem;
      justify-content: center;
      .btn {
        width: 4.56rem;
      }
    }
    .btn {
      @include btn;
    }
  }
}

</style>
